<!--经销商选择-->
<template>
    <Modal
            :value="visible"
            @on-visible-change="onVisibleChange"
            :title="title"
            @on-cancel="cancel"
            :footer-hide="true">
        <Input v-model="searchName" placeholder="请输入经销商名称" search enter-button
               @on-search="handleClickCusSelect"></Input>
        <CTable :height="400" :columns="columns" :data="queryData"
                :showPage="false"/>
    </Modal>
</template>

<script>

  import CTable from '../CTable'

  export default {
    name: "CusSelectDialog",
    model: {},
    components: {
      CTable
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: "经销商选择"
      },
      loadDataEnabled: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      "visible"(newVal) {
        if (newVal) {
          this.searchName = ''
          console.log('cus-select-dialog loadDataEnabled',this.loadDataEnabled)
          if (this.loadDataEnabled) {
            this.loadDataByName()
          }
        }
      },
    },
    data() {
      return {
        searchName: '',
        modal: false,
        queryData: [],
        columns: [{
          title: '经销商名称',
          key: 'cusName'
        },
          {
            title: '操作',
            key: 'action',
            fixed: 'right',
            width: 160,
            render: (h, params) => {
              return h('div', [
                h('a', {
                  on: {
                    click: () => {
                      this.$emit("on-select", params.row)
                    }
                  }
                }, '选择')
              ])
            }
          }]
      }
    },
    methods: {
      ok() {

      },
      cancel() {
      },
      loadDataByName(value) {
        this.$fetch('SysCus/getCodeName', {
          cusName: value
        }).then(res => {
          this.queryData = res.data.list
        })
      },
      handleClickCusSelect() {
        this.loadDataByName(this.searchName)
      },
      onVisibleChange(value) {
        this.$emit('update:visible', value)
      }
    }
  }
</script>

<style scoped>

</style>
